<template>
  <vl-column v-if="parentName" v-vl-spacer:top.large>
    <vl-link test-id="breadcrumb-parent" mod-bold :to="toRoute">{{ breadcrumbLabel }}</vl-link>
  </vl-column>
</template>

<script lang="ts" src="./dl-breadcrumb.ts"></script>
